import { createContext, useContext } from "react";

// Provides in-dialog navigation. When a descendant calls `dialogNavigate(path)`,
// the CoachProfileDialog swaps the view to match the given path instead of
// navigating the main BrowserRouter (which would close the dialog).
export const CoachProfileDialogContext = createContext(null);

export const useCoachProfileDialog = () => useContext(CoachProfileDialogContext);
